<template>
  <div
    :class="[
      'w-auto inline-block group transition duration-300 overflow-hidden',
    ]"
  >
    <slot></slot>

    <span
      :class="`block max-w-0 group-hover:max-w-full transition-all duration-500 h-0.5 bg-${twColor}`"
    ></span>
  </div>
</template>
<script setup lang="ts">
const { twColor = 'teal-700' } = defineProps<{ twColor?: string }>()
</script>
